import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import SplashScreen from './SplashScreen';


export default function RequireAuth() {
    const { username, privateKey, isLoggingOut } = useAuth();

    // Don't redirect while logging out - let the logout flow complete
    if (isLoggingOut) {
        return <SplashScreen />;
    }

    if (!username) {
        return <Navigate to="/login" replace />;
    }

    // If session exists but key is lost -> unlock
    if (!privateKey) {
        return <Navigate to="/unlock" replace />;
    }

    return <Outlet />;
}
